"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.pick = void 0;

var _getArrayIndex = _interopRequireDefault(require("./utils/get-array-index"));

var _getKey = _interopRequireDefault(require("./utils/get-key"));

var _is = _interopRequireDefault(require("./utils/is"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Pick
 * @template T, S
 * @description Reads value from object using dot notation path as key
 * @param {string} path
 * @param {T} source
 * @returns {T} value
 */
var pick = function pick(source, path) {
  if (_is.default.nullOrUndefined(path) || !path.trim()) {
    throw new SyntaxError("A dot notation path was expected, but instead got \"".concat(path, "\""));
  } // eslint-disable-next-line prefer-const


  var _ref = (0, _getKey.default)(path),
      _ref2 = _slicedToArray(_ref, 2),
      current = _ref2[0],
      remaining = _ref2[1];

  var match = (0, _getArrayIndex.default)(current.toString());

  if (match) {
    var index = match[1];

    if (!index) {
      throw new SyntaxError("An array index was expected but nothing was found at \"".concat(path, "\""));
    }

    if (Number.isNaN(+index)) {
      throw new TypeError("Array index must a positive integer \"".concat(index, "\""));
    }

    if (+index < 0) {
      throw new RangeError("Array index must be equal or greater than 0, but instead got \"".concat(index, "\""));
    }

    current = +index;
  }

  if (!remaining || !source[current]) {
    return source[current];
  }

  return pick(source[current], remaining);
};

exports.pick = pick;
var _default = pick;
exports.default = _default;